import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchBaseQueryWithTokenCheck } from '@shared/utils/api.utils';

import type { ApiKey } from './api-keys.types';

const API_KEYS_ENDPOINT = 'ApiKeys';

interface CreateApiKeyRequest {
  description: string;
  name: string;
}

interface CreateApiKeyResponse {
  key: string;
  message: string;
}

type CreateApiKeyWithRolesRequest = CreateApiKeyRequest & { roles: string[] };

export const apiKeysApiSlice = createApi({
  reducerPath: 'apiKeysApi',
  baseQuery: fetchBaseQueryWithTokenCheck,
  tagTypes: [API_KEYS_ENDPOINT],
  endpoints: (builder) => {
    return {
      getApiKeys: builder.query<ApiKey[], void>({
        query: () => '/api/v1/apikey',
        providesTags: [API_KEYS_ENDPOINT],
      }),

      createNewApiKey: builder.mutation<CreateApiKeyResponse, CreateApiKeyRequest>({
        query: (body) => ({
          url: '/api/v1/apikey',
          method: 'POST',
          body,
        }),
        invalidatesTags: [API_KEYS_ENDPOINT],
      }),

      createApiKeyWithRoles: builder.mutation<CreateApiKeyResponse, CreateApiKeyWithRolesRequest>({
        query: (body: CreateApiKeyWithRolesRequest) => ({
          url: '/api/v1/apikey/with-roles',
          method: 'POST',
          body,
        }),
        invalidatesTags: [API_KEYS_ENDPOINT],
      }),

      deleteApiKey: builder.mutation({
        query: (id: number) => ({
          url: `/api/v1/apikey/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: [API_KEYS_ENDPOINT],
      }),
    };
  },
});

export const { useGetApiKeysQuery, useCreateNewApiKeyMutation, useDeleteApiKeyMutation } = apiKeysApiSlice;
